
import {currencies} from "../../AppConstants";
import { find } from 'lodash';


export const getCurrencySymbol = (currency) => {
    if (!currency) {
        return ''
    }
    let element = find(currencies, x => x.value === currency);
    if (element) {
        return element.label;
    }

    return (0).toLocaleString(
        'ru-RU',
        {
            style: 'currency',
            currency: currency,
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        }
    ).replace(/\d/g, '').trim()
}
export const getCurrencyName = (currency) => {
    if (!currency) {
        return ''
    }
    let element = find(currencies, x => x.value === currency);
    if (element) {
        return element.name;
    }
    else {
        return ''
    }
}